import { Button, Stack, Typography } from '@mui/material';
import { Modal } from 'components/Modal';
import React, { useEffect, useState } from 'react';

export const DeleteConfirmationModal = ({ title = 'Remove subscriber', markedForDelete, mutateAsync }) => {
  const [open, setOpen] = useState(false);

  const { id, email } = markedForDelete || {};

  const handleCloseModal = () => setOpen(false);

  const handleConfirm = () => mutateAsync(id).then(handleCloseModal);

  useEffect(() => {
    if (markedForDelete) setOpen(true);
    else setOpen(false);
  }, [markedForDelete]);

  return (
    <Modal open={open} handleClose={handleCloseModal} title={title}>
      <Typography variant="body1" fontWeight={500}>
        Please confirm the removal of the subscriber{' '}
        <span style={{ fontWeight: 'bold' }}>{email}.</span>
      </Typography>

      <Stack direction="row" justifyContent="center" gap={1}>
        <Button variant="outlined" onClick={handleCloseModal}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleConfirm}>
          Confirm
        </Button>
      </Stack>
    </Modal>
  );
};
